const DISMISSED = '1';
const PREPARED = '2';
const INITIATED = '3';
const APPROVED = '4';
const REJECTED = '5';
const CANCELED = '6';

export default {
  DISMISSED,
  PREPARED,
  INITIATED,
  APPROVED,
  REJECTED,
  CANCELED
};
